module.exports = __webpack_public_path__ + "img/anadolusem-logo-vw.8ad3b64f.svg";